/**
 * `onOptions` of the shared filter wrappers (CU-869fmk5ge B1): a page that wants the options a filter loaded gets them
 * **after** the wrapper's own `onFinishAjax`, never instead of it. Passing `onFinishAjax` from a page replaces the
 * wrapper's handler (`{...props}` goes last): Tiers would lose `providersbyTiers` and throw on the next tier, Providers
 * `providersList`, Offices `officesOptions`, Categories `disableButton`.
 *
 * TL N1: a page that passes its own `onFinishAjax` to one of the four wrappers with a handler (Offices, Categories,
 * Tiers, Providers) still replaces it, as before, and then `onOptions` is not called either. No page does it today.
 *
 * `chainFinish(first, then)` → one handler that runs `first`, then `then`; either may be missing. No imports.
 */
export function chainFinish(first, then) {
	return options => {
		if (typeof first === 'function') first(options)
		if (typeof then === 'function') then(options)
	}
}
